export var SECTION_CONFIG = {
  floor_plan: ['video', 'photos'],
  video: ['floor_plan', 'photos'],
  photos: ['video', 'floor_plan'],
  carousel: ['floor_plan', 'video']
};
export var HEADER_HEIGHT = {
  desktop: 214,
  mobile: 168
};